export class BreakPoint {
    constructor() {
        this.RefreshValue();
    }
    RefreshValue() {
        this.Value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
    }
}
//# sourceMappingURL=BreakPoint.js.map